function getParameterByName(name, url) {
  let urlString = url;

  if (!url && !window.location) return null;
  if (!url) urlString = window.location.href;

  const nameString = name.replace(/[[\]]/g, "\\$&");
  const regex = new RegExp(`[?&]${nameString}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(urlString);

  if (!results) return null;
  if (!results[2]) return "";

  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function getQueryStringParams(query) {
  return query
    ? (/^[?]/.test(query) ? query.slice(1) : query)
        .split("&")
        .reduce((params, param) => {
          const [key, value] = param.split("=");
          return {
            ...params,
            [key]: value ? decodeURIComponent(value.replace(/\+/g, " ")) : "",
          };
        }, {})
    : {};
}

function paramsToQueryString(params) {
  if (!params || typeof params !== "object") return "";

  const keys = Object.keys(params);
  if (!keys || keys.length <= 0) return "";

  return keys.reduce((acc, key) => {
    return acc.length === 0
      ? `?${key}=${encodeURIComponent(params[key])}`
      : `${acc}&${key}=${encodeURIComponent(params[key])}`;
  }, "");
}

module.exports = {
  getParameterByName,
  getQueryStringParams,
  paramsToQueryString,
};
